<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}
</style>

<template>
  <div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('jinsanshitianshebeinenghaotop5') }}
        </p>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between;padding: 10px 0;" :style="{ height: chartHeight + 'px' }">
      <div id="monitorEnergyDevice305Chart" style="flex:1" :style="{ height: chartHeight - 20 + 'px' }"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_cockpit_produce_data',
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      timer: null,
      chart1: null,
      option1: null,
      chart2: null,
      option2: null,
      chartHeight: 0,
      produce: {}
    };
  },
  created() {},

  watch: {
    cockpitData(newValue, oldValue) {
      this.makeChart();
    }
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    makeChart() {
      let xData = this.cockpitData.top5In30.map(item => {
        return item.name;
      });
      let yData = this.cockpitData.top5In30.map(item => {
        return item.value;
      });
      this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
      if (!this.chart1) {
        setTimeout(() => {
          this.initChart1();
        }, 100);
      }
      setTimeout(() => {
        this.option1.xAxis.data = xData;
        this.option1.series[0].data = yData;
        this.chart1.setOption(this.option1);
      }, 200);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        if (!this.chart1) {
          return;
        }

        this.chart1.getDom().style.height = this.chartHeight - 20 + 'px';
        this.chart1.resize();
      }, 800);
    },
    initChart1() {
      this.option1 = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              formatter: '{value} '
            },
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: 'rgba(0,0,0,0.8)',
          borderWidth: 0,
          textStyle: {
            color: '#C0C4CC'
          },
          valueFormatter: value => {
            return value.toFixed(2) + 'kwh';
          }
        },
        grid: {
          left: '0',
          right: '10',
          bottom: '0',
          top: '10',
          containLabel: true
        },

        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: 'rgba(255, 255, 255,1'
            },
            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#CBCED4',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: false
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: false,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: '#C0C4CC'
            // formatter: month => {
            //   return month.substring(4, 6) + this.$t('yue');
            // }
          },
          data: this.produce.months
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            name: '',
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value} ',
              rotate: 0,
              textStyle: {
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('nenghao'),
            type: 'bar',
            barWidth: '12px',
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#FDC341'
                  },
                  {
                    offset: 1,
                    color: '#FF4941'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            label: {
              show: false,
              rotate: 0,
              color: '#419FFF',
              position: 'top',
              fontSize: 12
            },
            data: this.produce.goods
          }
        ]
      };

      var chartDom = document.getElementById('monitorEnergyDevice305Chart');
      this.chart1 = this.echarts.init(chartDom);
      this.option1 && this.chart1.setOption(this.option1);
    }
  }
};
</script>
